<!--
 * @Author: your name
 * @Date: 2020-11-18 15:05:12
 * @LastEditTime: 2021-04-07 17:17:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\components\news\notice.vue
-->
<template>
   <div class="notice">
            <h1>{{title}}<span>{{title2}}</span></h1>
            <ul>
                <li
                    v-for="notItem of rightList"
                    :key="notItem.id"
                    class="ellipsis"
                    @click="jumpDetail(notItem.id)"
                >
                    {{notItem.title}}
                    <p class="create_time">{{notItem.create_time_str}}</p>
                </li>
            </ul>
        </div>
</template>

<script>
export default {
    props:['title', 'title2','rightList','path'],
    mounted(){
    },
    methods:{
        jumpDetail(newid){
            let routeUrl = this.$router.resolve({
                path: '/noticeDetail',
                query: {
                  id: newid,
                  lang: this.$route.query.lang
                }
            })
             window.open(routeUrl.href, '_blank');
        }
    }
}
</script>

<style scoped lang="scss">
.notice {
    float: right;
    width: 28%;
    margin-top: 44px;
    background-color: #f5f5f5;
    padding: 30px 25px;
    h1 {
        text-align: center;
        width: 100%;
        height: 44px;
    }
    ul {
        margin-top: 15px;
       
        li {
            margin-bottom: 20px;
            cursor: pointer;
            p {
                color: #999999;
                margin-top: 5px;
            }
        }
    }
    .more {
        color: #04AD9F;
        cursor: pointer;
        text-align: center;
        border-top: 1px solid #ddd;
        padding-top:15px ;
    }
}
>>> .el-link span {
    line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/news/components/notice.vue